import { parseCookies } from 'nookies';
import axios, { AxiosInstance, AxiosHeaders } from 'axios';

import { signOut } from '~/modules/auth/hooks/auth';

import { AuthTokenError } from '../errors/AuthTokenError';
import { env } from '../constants/env';
import { cookies } from '../constants/cookies';

export function setupApi(ctx = undefined): AxiosInstance {
  const api = axios.create({
    baseURL: env.API_URI,
  });

  api.interceptors.request.use((config) => {
    const { [cookies.AUTH_TOKEN]: token } = parseCookies(ctx);

    if (token) {
      (config.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`);
    }

    return config;
  });

  api.interceptors.response.use(
    (success) => success,
    (error) => {
      if (error.response?.status === 401) {
        if (error.response?.data?.code === 'token_expired') {
          if (typeof document !== 'undefined') {
            signOut();
          } else {
            return Promise.reject(new AuthTokenError());
          }
        }
      }

      return Promise.reject(error);
    }
  );

  return api;
}

export const api = setupApi();
